import * as React from "react"
import { Box } from "@theme-ui/components"
import Nav from "./nav"
import MobileNav from "./mobileNav"
import { useColorMode } from "theme-ui"
const Header = ({ locale, background, primaryNav }) => {
  const colorMode = useColorMode()

  console.log(background)
  console.log(primaryNav)
  return (
    <Box
      as="header"
      sx={{
        position: "fixed",
        width: "100%",
        zIndex: "9999",
        fontFamily: "mono",
      }}
    >
      <Box
        sx={{
          display: ["none", "none", "none", "block"],

          zIndex: 4,
        }}
      >
        <Nav primaryNav={primaryNav} background={background} locale={locale} />
      </Box>
      <Box sx={{ display: ["block", "block", "block", "none"], zIndex: 4 }}>
        <MobileNav
          primaryNav={primaryNav}
          background={background}
          locale={locale}
        />
      </Box>
    </Box>
  )
}

export default Header
